require('./assets/stylesheets/main.scss');
export { default as StatusTimeline } from './components/StatusTimeline';
export { default as DashBoardStatusTimeline } from './components/DashBoardStatusTimeline';
export { default as VerificationTimeline } from './components/VerificationTimeline';
export { getSkippedSteps, getTimelineStatusMap } from './utils/common';

// import React, { useState } from 'react';
// import ReactDOM from 'react-dom';
// import VerificationTimeline from './components/VerificationTimeline';
// import DashBoardStatusTimeline from './components/DashBoardStatusTimeline';

// const statusIcons = {
//   COMPLETED: 'http://dev-onboarding.payu.in/assets/images/onboarding/ok-icon.svg',
//   IN_PROGRESS: 'http://dev-onboarding.payu.in/assets/images/onboarding/progress-icon.svg',
//   LOCKED: 'http://dev-onboarding.payu.in/assets/images/onboarding/pending-icon.svg',
//   FAILURE: 'http://dev-onboarding.payu.in/assets/images/onboarding/error-icon.svg'
// };

// const uiConfig = {
//   steps: [
//     {
//       id: 'pan-details',
//     },
//     {
//       id: 'business-details',
//     },
//     {
//       id: 'bank-details',
//     },
//     {
//       id: 'signing-authority',
//     },
//     {
//       id: 'website-details',
//     },
//     {
//       id: 'kyc',
//     },
//   ]
// };


// const TimelineContainer = () => {
// let [refreshSignal, setSignal] = useState(false);

//   // setInterval(() => {
//   //   setSignal(!refreshSignal);
//   // }, 5000);

//   return (
//     <div className='container'>
//       <div className='row mt-5'>
//         <div className='col-md-10 m-auto'>
//           <VerificationTimeline
//             refreshSignal={refreshSignal}
//             statusTimelineEndpoint='/api/v2/merchants/status_timeline'
//             authToken='53f3c0141501a43f9b1d9881fece7f6b6d79c88815eab0dc7dcb85ff5b517c17'
//             mid='7600653'
//             statusIcons={statusIcons}
//             uiConfig={uiConfig}
//           />
//         </div>
//       </div>
//     </div>
//   )
// }

// //render Verification timeline
// ReactDOM.render(
//   <TimelineContainer/>,
//   document.getElementById('container')
// );

// // // render Dashboard version of timeline
// // ReactDOM.render(
// //   <DashBoardStatusTimeline
// //     dashBoardServiceHost='http://10.248.7.133'
// //     onboardingHost='https://test10-onboarding.payu.in'
// //     careHost='https://test-help.payu.in'
// //     mid='180310'
// //     product='PayUbiz'
// //     authToken='66a71b80cd06910b4f5ce07ccd75ceeec39c9fe69398e4e5df25a2902ea1b22a'
// //   />,
// //   document.getElementById('container')
// // );
